/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { ResourceTagsTableCell } from "../../../Shared/ResourceTagsTableCell";
import type { ResourceTagSummary } from "kontrolEdge/components/Shared/NameTagEdit/useResourceTags";
import { mapKeListResourceTags } from "../../../Shared/mapKeListResourceTags";

export interface CloudConnectivity {
  id: number | string;
  name: string;
  tagsRich?: ResourceTagSummary[];
  isDraft: boolean;
  subscriptionId: string;
  tenantNameDisplay: string;
  // Detail response fields
  kontrolEdgePortId?: number;
  mbps?: number | string;
  vlan?: number | string;
  automaticVlan?: boolean;
  terms?: number | string;
  autoRenew?: boolean | null;
  kontrolEdgeLagId?: number | null;
  provider?: string;
  providerId?: string;
  providerAccount?: number;
  cloud?: string;
  account?: string;
  monitoring?: {
    enable?: boolean;
    maintenance_mode?: boolean;
  };
  createdAt?: string;
  updatedAt?: string;
  odooMetadata?: {
    lineId?: number;
    orderId?: number;
    correlation?: string;
    parentCorrelation?: string;
  } | null;
  kontrolEdgePort?: {
    id?: number;
    subid?: string;
    name?: string;
    tenantId?: number;
    datacenterId?: string;
    hardwareId?: string;
    capacityMbps?: number;
    tenant?: {
      id?: number;
      Name?: string;
      nameDisplay?: string;
      chargebeeCustomerId?: string;
    };
    datacenter?: {
      datacenterId?: string;
      name?: string;
      displayName?: string;
      city?: string;
    };
    hardware?: {
      id?: number;
      hostname?: string;
      model?: string;
    } | null;
  };
}

/**
 * Define table columns for Cloud Connectivity services
 */
export const columns: GenericTableColumn<CloudConnectivity>[] = [
  {
    header: "Name",
    accessor: "name",
  },
  {
    header: "Tag",
    renderCell: (row) => (
      <ResourceTagsTableCell
        tagsRich={row.tagsRich}
        maxVisible={1}
      />
    ),
  },
  {
    header: "Status",
    renderCell: (row) => (
      <GenericTag
        variant={row.isDraft ? "warning" : "success"}
        label={row.isDraft ? "Draft" : "Active"}
        size="small"
      />
    ),
  },
  {
    header: "Subscription ID",
    accessor: "subscriptionId",
  },
  {
    header: "Tenant",
    accessor: "tenantNameDisplay",
  },
];

/**
 * Shape API response data to match CloudConnectivity interface
 */
export const shapeCloudConnectivityData = (rows: any[]): CloudConnectivity[] =>
  rows.map((r) => {
    const tagsRich = mapKeListResourceTags(r);
    return {
    id: r.id ?? "",
    name: r.name ?? r.subscriptionId ?? "",
    tagsRich,
    isDraft: Boolean(r.isDraft),
    subscriptionId: r.subscriptionId ?? "",
    tenantNameDisplay: r.tenant?.nameDisplay ?? r.kontrolEdgePort?.tenant?.nameDisplay ?? "",
    // Detail response fields
    kontrolEdgePortId: r.kontrolEdgePortId,
    mbps: r.mbps,
    vlan: r.vlan,
    automaticVlan: Boolean(r.automaticVlan),
    terms: r.terms,
    autoRenew: r.autoRenew,
    kontrolEdgeLagId: r.kontrolEdgeLagId,
    provider: r.provider,
    providerId: r.providerId,
    providerAccount: r.providerAccount,
    cloud: r.cloud,
    account: r.account,
    monitoring: r.monitoring,
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    odooMetadata: r.odooMetadata,
    kontrolEdgePort: r.kontrolEdgePort,
  };
  });

